import { createSlice } from '@reduxjs/toolkit';

const pageSlice = createSlice({
    name: 'pageSlice',
    initialState: {
      activeMenu: "Digital Class Management",
      isMenuExpended: true,
      lactureManagementClassId:null,
      lactureManagementClassName:null,
      lactureManagementSectionId:null,
      lactureManagementSectionName:null,

    },
    reducers: {
      setActiveMenu: (state, action) => {
        state.activeMenu = action.payload
      },
      setIsMenuExpended: (state, action) => {
        state.isMenuExpended = action.payload
      },
      setLactureManagementClassId: (state, action) => {
        state.lactureManagementClassId = action.payload
      },
      setLactureManagementClassName: (state, action) => {
        state.lactureManagementClassName = action.payload
      },
      setLactureManagementSectionId: (state, action) => {
        state.lactureManagementSectionId = action.payload
      },
      setLactureManagementSectionName: (state, action) => {
        state.lactureManagementSectionName = action.payload
      },
    },
    
  });
  
  
  export const { setActiveMenu, setIsMenuExpended,setLactureManagementClassId,setLactureManagementClassName,setLactureManagementSectionId,setLactureManagementSectionName} = pageSlice.actions;
  export default pageSlice.reducer;